// extracted by mini-css-extract-plugin
module.exports = {"epis_box":"episode-list_epis_box__1HozO","imgfilm":"episode-list_imgfilm__3QL3D"};